<template>
  <WsMain>
    <WsCRUD
      orderWay="asc"
      orderBy="sequence"
      :label="label"
      :fields="fields"
      :modelName="modelName"
      :showFields="showFields"
    />
  </WsMain>
</template>

<script>
import model from '@/models/itemLabelType';

export default {
  data() {
    return {
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      'sequence',
      'name',
      'value',
      'is_active',
      'updated_at',
      'updated_admin',
    ],
  }},
};
</script>